import mixpanel from 'mixpanel-browser'
import React, { createContext, useContext } from 'react'
import { useAuth } from './AuthProvider'

export const MIXPANEL_KEY = process.env.REACT_APP_MIXPANEL_KEY as string

type AnalyticsContextProps = {
  analyticsTrack: (eventName: string, customProps?: object) => void
}

const AnalyticsContext = createContext<AnalyticsContextProps>({
  analyticsTrack: () => null,
})

const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth()
  const analyticsTrack = (eventName: string, customProps?: object) => {
    mixpanel.track(eventName, {
      userEmail: user?.email,
      ...(customProps || {}),
    })
  }

  const myWindow = window as unknown as {
    Cookiebot: { consent: { statistics: unknown } }
  }
  const value =
    MIXPANEL_KEY && myWindow?.Cookiebot?.consent?.statistics
      ? { analyticsTrack }
      : { analyticsTrack: () => null }

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export const useAnalytics = () => useContext(AnalyticsContext)

export default AnalyticsProvider
